<script lang="ts" setup>
  import { definePage } from 'unplugin-vue-router/runtime'
  import { useI18n } from 'vue-i18n'
  import UpdatePasswordForm from '@/components/profile/UpdatePasswordForm.vue'

  const { t } = useI18n()
  definePage({
    meta: {
      authenticated: true,
      title: 'update_password',
    },
  })
  const router = useRouter()

  const onSuccess = () => {
    snackbarColor.value = 'success'
    snackbarText.value = t('password_updated_successfully')
    snackbar.value = true

    setTimeout(() => {
      router.push({ name: 'root' })
    }, 2000)
  }

  const snackbar = ref(false)
  const snackbarText = ref('')
  const snackbarColor = ref('success')
</script>

<template>
  <v-container
    class=""
    :class="{
      'h-screen': $vuetify.display.smAndDown,
      'bg-surface': $vuetify.display.smAndDown
    }"
  >
    <v-card
      class="mx-auto pt-sm-3 px-sm-4 pb-sm-5 pa-0"
      elevation="0"
      max-width="540"
    >
      <v-card-title class="font-weight-bold text-h6 pa-0 mb-3">
        <div class="d-flex align-center ga-3 text-gray-100">
          <v-btn
            class="p-0 m-0"
            icon="mdi-arrow-right"
            :ripple="false"
            size="32"
            :to="{name:'root'}"
            variant="text"
          />
          <i18n-t keypath="update_password" />
        </div>
      </v-card-title>
      <v-card-subtitle class="mb-5 px-0 text-subtitle-2">
        <i18n-t keypath="update_password_subtitle" />
      </v-card-subtitle>
      <update-password-form @on-success="onSuccess" />
    </v-card>

    <v-snackbar
      v-model="snackbar"
      close-delay="5"
      close-on-content-click
      :color="snackbarColor"
    >
      <div class="text-center">{{ snackbarText }}</div>
    </v-snackbar>
  </v-container>
</template>

<style scoped>
</style>
